// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";
import BannerLayout from "./layouts/BannerLayout";
import ProductLayout from "./layouts/ProductLayout";
import ContentLayout from "./layouts/ContentLayout";
import StoryLayout from "./layouts/StoryLayout";
import CreateContentPage from "./pages/CreateContentPage";
import ContentEditPage from "./pages/ContentEditPage";
import StoryEditPage from "./pages/StoryEditPage";
import DashBoardLayout from "./layouts/DashboardLayout";
import SolapiLayout from "./layouts/SolapiLayout";

const App = () => {
  // 로그인 여부 확인 (글로벌)
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    const isLoggedIn = window.sessionStorage.getItem("login");
    console.log(isLoggedIn);
    setIsAuthenticated(isLoggedIn === "loggin");
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={isAuthenticated ? <AdminLayout /> : <Navigate to="/login" />}
        >
          <Route path="dashboard" element={<DashBoardLayout />} />
          <Route path="user" element={<UserLayout />} />
          <Route path="solapi" element={<SolapiLayout />} />
          <Route path="banners" element={<BannerLayout />} />
          <Route path="products" element={<ProductLayout />} />
          <Route path="contents" element={<ContentLayout />} />
          <Route path="dpcontents" element={<StoryLayout />} />
          <Route path="contents/create" element={<CreateContentPage />} />
          <Route path="contents/edit" element={< ContentEditPage/>} />
          <Route path="dpcontents/edit" element={<StoryEditPage />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
